
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="min-h-screen relative">
          {/* Mystical Background Image */}
          <div 
            className="fixed inset-0 z-0"
            style={{
              backgroundImage: `url('https://public.readdy.ai/ai/img_res/3315dd06c3e67642f54e90e5d56d0279.jpg')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundAttachment: 'fixed',
              opacity: 0.85
            }}
          />

          {/* Gradient Overlay for better text readability */}
          <div 
            className="fixed inset-0 z-0 bg-gradient-to-b from-purple-900/20 via-transparent to-pink-900/20"
          />
          
          {/* Content */}
          <div className="relative z-10">
            <AppRoutes />
          </div>
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
